<template>
  <UModal
    v-model:open="open"
    :dismissible="false"
    :close="false"
    :ui="{
      content: 'p-0 gap-0',
      body: 'p-6 sm:p-6',
      footer: 'p-4 sm:p-4 justify-center gap-2',
    }"
  >
    <template #body>
      <div class="flex flex-col items-center gap-2">
        <div
          :class="bodyGradient"
          class="-mx-6 -mt-6 flex w-[calc(100%+3rem)] flex-col items-center gap-2 px-6 pt-6 pb-2"
        >
          <AppLabelWithIcon
            :icon="iconComputed"
            :title="props.title"
            :color="props.type"
            orientation="vertical"
          />
        </div>
        <slot name="description">
          <span
            v-if="props.description !== undefined"
            class="text-base font-medium text-neutral-400"
          >
            {{ props.description }}
          </span>
        </slot>

        <slot name="content">
          <component
            v-if="props.content !== undefined"
            :is="props.content"
          ></component>
        </slot>
      </div>
    </template>
    <template #footer>
      <slot name="footer">
        <div class="flex flex-col sm:flex-row justify-between gap-2">
          <UButton
            v-for="(action, id) in props.actions"
            v-bind="{
              ...action,
              class: `min-w-30 ${action.class}`,
            }"
            :key="id"
            size="lg"
          >
          </UButton>
        </div>
      </slot>
    </template>
  </UModal>
</template>

<script setup lang="ts">
import type { AlertModalOptions } from "@/utils/types/alert";

const props = ref<AlertModalOptions>({
  type: "info",
  showBackground: false,

  hideIcon: false,
  title: undefined,
  icon: undefined,
  description: undefined,
  actions: undefined,
  content: undefined,
});

const iconComputed = computed(() => {
  if (props.value.icon) return props.value.icon;
  return {
    success: "i-somas-circle-check",
    warning: "i-somas-triangle-warning",
    info: "i-somas-circle-help",
    error: "i-somas-trash-full",
  }[props.value.type];
});

const bodyGradient = computed(() => {
  if (!props.value.showBackground) return "";
  return {
    success: "bg-gradient-to-b from-[#E8F7E8] to-[#FFFFFF] to-100%",
    warning: "bg-gradient-to-b from-[#FDF4E2] to-[#FFFFFF] to-100%",
    info: "bg-gradient-to-b from-[#E7F8F7] to-[#FFFFFF] to-100%",
    error: "bg-gradient-to-b from-[#FCE3E3] to-[#FFFFFF] to-100%",
  }[props.value.type];
});

const open = ref(false);
const show = (data: AlertModalOptions) => {
  props.value = {
    ...props.value,
    ...data,
  };

  open.value = true;
};

const hide = () => {
  open.value = false;
};

defineExpose({ show, hide });
</script>

<style scoped></style>
